import { render, staticRenderFns } from "./pmgys.vue?vue&type=template&id=e898352e&scoped=true&"
import script from "./pmgys.vue?vue&type=script&lang=js&"
export * from "./pmgys.vue?vue&type=script&lang=js&"
import style0 from "./pmgys.vue?vue&type=style&index=0&id=e898352e&scoped=true&lang=css&"
import style1 from "./pmgys.vue?vue&type=style&index=1&id=e898352e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e898352e",
  null
  
)

export default component.exports